namespace TR {

    interface PaymentData {
        minimumDeposit :number;
        products :PaymentProduct[];
        totalBalances :number;
    }

    interface PaymentProduct {
        balance :number;
        currentDeposit :number;
        directPayments :DirectPayment[];
        initialDeposit :number;
        productTitle :string;
        productType :number;
        schedule :PaymentSchedule[];
    }

    interface DirectPayment {
        amount :number;
        currency :string;
        localAmount :number;
        localCurrency :string;
    }

    interface PaymentSchedule {
        amount :number;
        balance :number;
        due :Date;
    }

    interface KeyModel {
        conversion :string;
        noConversion :string;
    }

    class DirectPaymentInformation {

        private keyMap : { [type :number] :KeyModel } = {};
        private hasFootnote :string;

        public paymentData :PaymentData;
        public showDirectPayments :boolean;

        constructor(private $filter: ng.IFilterService,
                    private resourceService: Core.ResourceService,
                    private $scope:ng.IScope) {

            //decide which resource keys we want to push in to our object based on the footnote scope value
            let m = {
                conversion :'',
                noConversion :''
            };

            if (this.hasFootnote === 'true') {
                m.conversion = 'DIRECTPAYMENTTOHOTELCONVERTED';
                m.noConversion = 'DIRECTPAYMENTTOHOTEL';
            } else {
                m.conversion = 'DIRECTPAYMENTTOHOTELCONVERTEDNONOTE';
                m.noConversion = 'DIRECTPAYMENTTOHOTELNONOTE';
            }

            this.keyMap[0] = m; //add the keys for hotels to the map
        }

        public directPaymentCaveat(product, payment) {
            const res = product.productType === 0 ? 'DIRECTACCOMPAYMENTADVICE' : 'DIRECTFLIGHTPAYMENTADVICE';
            if (payment.localCurrency === payment.currency) {
                return String.format(this.resourceService.get(res),
                this.$filter('customCurrency')(payment.amount, payment.currency));
            }
            return String.format(this.resourceService.get(res),
            `${this.$filter('customCurrency')(payment.localAmount, payment.localCurrency)} 
            ${String.format(this.resourceService.get('CUSTOMEREQUIVALENT'),
            this.$filter('customCurrency')(payment.amount, payment.currency))}`);
        }


        public getText(productType :number, payment :DirectPayment) :string {
            const paymentAmount = this.$filter('customCurrency')(payment.amount, payment.currency);
            const resource = this.keyMap[productType];

            if (productType === 0) {

                if (payment.localCurrency === payment.currency) {
                    return String.format(this.resourceService.get(resource.noConversion), paymentAmount);
                } else {
                    return String.format(this.resourceService.get(resource.conversion),
                                         this.$filter('customCurrency')(payment.localAmount, payment.localCurrency),
                                         paymentAmount
                                        );
                }
            }
            return '';
        }

    }

    angular
        .module('TR')
        .directive('directPaymentInformation', (): ng.IDirective => {
            return {
                scope: {
                    hasFootnote: '@',
                    paymentData: '=',
                    showDirectPayments: '='
                },
                templateUrl: (element, attr) => {
                    if (attr.templateVersion){
                        return 'partials/booking/template?name=DirectPaymentInformation&version='+ attr.templateVersion;
                    }
                    return 'partials/home/directivetemplate?type=DirectPaymentInformation';
                },
                bindToController: true,
                controller: DirectPaymentInformation,
                controllerAs: 'dpi',
                replace: true
            };
        });
}
